import React from "react";

import {

  Alert,

  Box,

  Checkbox,

  Chip,

  FormControlLabel,

  Paper,

  Stack,

  Typography,

} from "@mui/material";

import type { TeamCandidate } from "./teamFormationTypes";

import { statusLabel } from "./teamFormationMockData";

import {
  teamCandidateStatusBadgeSx,
  teamCandidateTypeBadgeSx,
  TEAM_INFO_BG,
  TEAM_INFO_BORDER,
  TEAM_INFO_TEXT,
  TEAM_LINK,
  TEAM_MUTED,
  TEAM_TEXT,
} from "./teamFormationUi";



type Props = {

  candidate: TeamCandidate;

  disabled?: boolean;

  onToggle: (inConsideration: boolean) => void;

};



export default function CandidateCard({ candidate, disabled, onToggle }: Props) {

  const inConsideration = candidate.status === "IN_CONSIDERATION";

  const toggleDisabled =

    disabled ||

    candidate.status === "APPROVED_PROSPECT" ||

    candidate.status === "SUBMITTED_FOR_REVIEW";



  const toggleLabel =

    candidate.status === "APPROVED_PROSPECT"

      ? "Approved"

      : candidate.status === "SUBMITTED_FOR_REVIEW"

        ? "Submitted"

        : "In Consideration";



  return (

    <Paper

      component="article"

      variant="outlined"

      sx={{

        p: 1.5,

        borderRadius: "8px",

        borderColor: "#DEE2E6",

        bgcolor: "#FFFFFF",

        boxShadow: "0 1px 2px rgba(16, 24, 40, 0.04)",

      }}

    >

      <Box

        sx={{

          display: "grid",

          gridTemplateColumns: {

            xs: "1fr",

            md: "minmax(220px, 1.2fr) minmax(180px, .8fr) minmax(170px, .7fr) auto",

          },

          gap: 1.5,

          alignItems: "center",

        }}

      >

        <Box>

          <Typography
            sx={{
              fontSize: "0.9375rem",
              fontWeight: 800,
              color: TEAM_TEXT,
              lineHeight: 1.35,
            }}
          >

            {candidate.displayName}

          </Typography>

          <Typography sx={{ fontSize: "0.8125rem", color: TEAM_MUTED, mt: 0.25 }}>

            {candidate.parishName}

            {candidate.language ? ` · ${candidate.language}` : ""}

          </Typography>

          <Stack

            direction="row"

            spacing={0.75}

            sx={{ mt: 0.75, flexWrap: "wrap", gap: 0.5 }}

          >

            <Chip
              size="small"
              label={
                candidate.firstTimeTeamCandidate
                  ? "First-Time Team Candidate"
                  : "Experienced Team Candidate"
              }
              sx={teamCandidateTypeBadgeSx(candidate.firstTimeTeamCandidate)}
            />
            <Chip
              size="small"
              label={statusLabel(candidate.status)}
              sx={teamCandidateStatusBadgeSx(candidate.status)}
            />

          </Stack>

        </Box>



        <Box>

          <Typography sx={{ fontSize: "0.75rem", color: TEAM_MUTED }}>

            Last Retreat attended:

          </Typography>

          <Typography sx={{ fontSize: "0.875rem", fontWeight: 700, color: TEAM_TEXT }}>

            {candidate.lastRetreatAttended.parishName}

          </Typography>

          <Typography sx={{ fontSize: "0.75rem", color: TEAM_MUTED }}>

            {candidate.lastRetreatAttended.weekend}

          </Typography>

        </Box>



        <Box>

          <Typography sx={{ fontSize: "0.75rem", color: TEAM_MUTED }}>

            Prior Team history:

          </Typography>

          <Typography sx={{ fontSize: "0.875rem", fontWeight: 700, color: TEAM_TEXT }}>

            {candidate.teamsServed} Teams served

          </Typography>

          {candidate.priorRoles.length > 0 && (

            <Typography sx={{ fontSize: "0.75rem", color: TEAM_MUTED }}>

              {candidate.priorRoles.join(" · ")}

            </Typography>

          )}

        </Box>



        <FormControlLabel

          control={

            <Checkbox

              size="small"

              checked={inConsideration}

              disabled={toggleDisabled}

              onChange={(_, checked) => onToggle(checked)}

              sx={{

                color: "#9CA3AF",

                "&.Mui-checked": { color: TEAM_LINK },

              }}

            />

          }

          label={

            <Typography sx={{ fontSize: "0.875rem", color: TEAM_TEXT }}>

              {toggleLabel}

            </Typography>

          }

          sx={{ m: 0, alignItems: "center" }}

        />

      </Box>



      {candidate.commitments.map((commitment) => (

        <Alert

          key={commitment.retreatId}

          severity="info"

          icon={false}

          sx={{

            mt: 1,

            bgcolor: TEAM_INFO_BG,

            color: TEAM_INFO_TEXT,

            border: `1px solid ${TEAM_INFO_BORDER}`,

            borderRadius: "8px",

            fontSize: "0.8125rem",

            py: 0.75,

          }}

        >

          Existing commitment: {commitment.retreatName}

          {commitment.weekend ? ` · ${commitment.weekend}` : ""}. This does not

          automatically exclude the couple.

        </Alert>

      ))}



      {candidate.concernComment && (

        <Alert severity="warning" sx={{ mt: 1, fontSize: "0.8125rem" }}>

          Governance concern: {candidate.concernComment}

        </Alert>

      )}

    </Paper>

  );

}


